import { Injector, Pipe, PipeTransform } from '@angular/core';
import * as moment from '@node_modules/moment';

@Pipe({
  name: 'humanizeDateString',
})
export class HumanizeDateStringPipe implements PipeTransform {
  constructor() {}

  transform(input: string): string {
    const feature = moment(input);
    const today = moment().endOf('day');
    const tomorrow = moment().add(1, 'day').endOf('day');
    const yesterday = moment().subtract(1, 'day').endOf('day');

    if (feature.isSame(today, 'day')) {
      return 'Today';
    }

    if (feature.isSame(tomorrow, 'day')) {
      return 'Tomorrow';
    }

    if (feature.isSame(yesterday, 'day')) {
      return 'Yesterday';
    }

    return feature.format('DD/MM/YY');
  }
}
